module.exports = __webpack_public_path__ + "img/nantong.8e6de25e.jpg";